module.exports = __webpack_public_path__ + "img/lonjas.6f65eb5e.svg";